import Loading from 'components/Loading'
import Loadable from 'react-loadable'
import { Route } from 'react-router-dom'
import React from 'react'

// eslint-disable-next-line no-new

const Component = Loadable({
  loader: () => import('./Hint'),
  render(loaded, props) {
    const Component = loaded.default

    return <Component {...props} />
  },
  loading: Loading,
})
export default function(route) {
  return <Route path={`${route.match.path}`} render={(routeProps) => <Component {...routeProps} />} />
}
